var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "page news" },
    [
      _c("article", [
        _c("div", {
          staticClass: "intro",
          domProps: { innerHTML: _vm._s(_vm.content) }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "content",
          class: { hidden: !_vm.contentVisible },
          domProps: { innerHTML: _vm._s(_vm.contentScroll) }
        })
      ]),
      _vm._v(" "),
      _c("site-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }